import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useMapStore } from '../store/mapStore';
import PageBanner from '../components/Layout/PageBanner';
import MapDisplay from '../components/Map/MapDisplay';

export default function MapView() {
  const location = useLocation();
  const { fromLeases, selectedLease } = location.state || {};
  const setSelectedLease = useMapStore(state => state.setSelectedLease);

  React.useEffect(() => {
    if (fromLeases && selectedLease) {
      setSelectedLease(selectedLease);
    }
  }, [fromLeases, selectedLease, setSelectedLease]);

  return (
    <div className="h-[calc(100vh-5rem)] flex flex-col">
      <PageBanner />
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900">Sub-Lease Map</h1>
      </div>
      
      <div className="flex-1 min-h-0 bg-white rounded-lg shadow-md overflow-hidden z-0">
        <MapDisplay />
      </div>
    </div>
  );
}
